import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionStatusBadge = ({ status, size = 'default' }) => {
  const getStatusConfig = (status) => {
    const configs = {
      pending: {
        label: 'Pending',
        icon: 'Clock',
        className: 'bg-warning/10 text-warning border-warning/20'
      },
      processing: {
        label: 'Processing',
        icon: 'Loader2',
        className: 'bg-blue-100 text-blue-700 border-blue-200 animate-spin'
      },
      compliance_review: {
        label: 'Compliance Review',
        icon: 'Shield',
        className: 'bg-purple-100 text-purple-700 border-purple-200'
      },
      aml_check: {
        label: 'AML Check',
        icon: 'Search',
        className: 'bg-indigo-100 text-indigo-700 border-indigo-200'
      },
      pep_screening: {
        label: 'PEP Screening',
        icon: 'UserCheck',
        className: 'bg-cyan-100 text-cyan-700 border-cyan-200'
      },
      funds_reserved: {
        label: 'Funds Reserved',
        icon: 'Lock',
        className: 'bg-orange-100 text-orange-700 border-orange-200'
      },
      sent_to_bank: {
        label: 'Sent to Bank',
        icon: 'Building2',
        className: 'bg-teal-100 text-teal-700 border-teal-200'
      },
      in_transit: {
        label: 'In Transit',
        icon: 'Truck',
        className: 'bg-blue-100 text-blue-700 border-blue-200'
      },
      completed: {
        label: 'Completed',
        icon: 'CheckCircle',
        className: 'bg-success/10 text-success border-success/20'
      },
      failed: {
        label: 'Failed',
        icon: 'XCircle',
        className: 'bg-error/10 text-error border-error/20'
      },
      cancelled: {
        label: 'Cancelled',
        icon: 'Ban',
        className: 'bg-gray-100 text-gray-700 border-gray-200'
      }
    };

    return configs?.[status] || configs?.pending;
  };

  const config = getStatusConfig(status);
  const sizeClasses = size === 'sm' ? 'px-2 py-1 text-xs' : 'px-3 py-1 text-sm';
  const iconSize = size === 'sm' ? 12 : 14;

  return (
    <span className={`inline-flex items-center space-x-1 rounded-full border font-medium ${sizeClasses} ${config?.className}`}>
      <Icon name={config?.icon} size={iconSize} />
      <span>{config?.label}</span>
    </span>
  );
};

export default TransactionStatusBadge;